<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay">
    <v-card>
      <v-card-title>Get QR Codes from Park</v-card-title>
      <v-card-title>
        <v-autocomplete
          label="Park from which get the QR Codes"
          :items="parks"
          v-model="parkToQueryId"
          item-title="name"
          item-value="id"
        />
      </v-card-title>
      <template v-if="parkToQueryId">
        <v-divider/>
        <v-card-text>
          <v-container>
            <v-row>
              <template v-if="chargingstations.length > 0">
                <v-col v-for="cs in chargingstations">
                  <v-card>
                    <v-card-title><b>CS N.{{ cs['park_bnum'] }}</b></v-card-title>
                    <v-card-title>BNUM: {{ cs['bnum'] }}</v-card-title>
                    <v-card-title>QRCode: {{ cs['qrcodeid'] }}</v-card-title>
                  </v-card>
                </v-col>
              </template>
              <v-col v-else>
                <p class="text-center"><b>No Chargingstation Found</b></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { ref, onMounted, watch } from "vue";
import { fetchParkById, fetchParks } from "../remote/park.js";
import { objComparatorNumber } from "../utils.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const parks = ref([]);
const parkToQueryId = ref(null);
const chargingstations = ref([]);

watch(parkToQueryId, async (newValue) => {
  if (newValue !== null) {
    loadingOverlay.value = true;
    try {
      const parkdata = await fetchParkById(newValue);
      chargingstations.value = parkdata['chargingstations'].sort((a, b) => objComparatorNumber(a, b, 'park_bnum'));
    } catch (e) {
      useAlerts.value.errorAlert(`Error during Park ${newValue} retrieve`, e.toString());
    }
    loadingOverlay.value = false;
  }
});

// Hook
onMounted(async () => {
  loadingOverlay.value = true;
  try {
    // Retrieve Parks
    parks.value = await fetchParks();
  } catch (e) {
    useAlerts.value.errorAlert('Error during Parks retrieve', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});
</script>

<style scoped>

</style>
